import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
import { createBrowserHistory } from 'history';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CondicaoPagamentoController from '../../../../controllers/CondicaoPagamentoController';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useLocation} from 'react-router-dom';

export default function CondicaoPagamentoCadastrar() {
  const { userId } = useSelector((state: any) => state.Authentication);

  const history = createBrowserHistory();
  const [single, setSingle] = useState<any>(null);
  const { id } = useParams();
  const condicaopagamentoId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {
    if (condicaopagamentoId !== null && condicaopagamentoId !== undefined) {
      getSingle(condicaopagamentoId);
    }
  }, [condicaopagamentoId]);

  const getSingle = async (condicaopagamentoId: number) => {
    const Response =
      await CondicaoPagamentoController.ListarUnico(condicaopagamentoId);

    setSingle(Response.Data);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (condicaopagamentoId === null) {
      const response = await CondicaoPagamentoController.Adicionar(values);

      if (response.StatusCode === 204) {
        toast('Condição de pagamento incluída com sucesso!', {
          type: 'success'
        })
        resetForm();
      } else {
        toast('Erro ao incluir a condição de pagamento!', {
          type: 'error'
        })
        resetForm();
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      condicaopagamentoId: condicaopagamentoId,
      ...values,
    };

    const response = await CondicaoPagamentoController.Atualizar(request);

    if (response.StatusCode === 204) {
      toast('Condicao de Pagamento atualizado com sucesso!', {
        type: 'success'
      })
    } else {
      toast('Erro ao atualizar a Condicao de Pagamento!', {
        type: 'error'
      })
    }

    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    Descricao: single?.cpg_descricao || '',
    TipoUtilizacao: single?.cpg_tipo_Utilizacao || '',
    TipoParcelamento: single?.cpg_tipo_parcelamento || '',
    Quantidade: single?.cpg_quantidade || '',
    DiasParcelas: single?.cpg_dias_parcelas || '',
  };
  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatório!')
      .min(3, 'O Campo deve ter no mínimo 3 caracteres'),
    TipoUtilizacao: Yup.string(),
    TipoParcelamento: Yup.string(),
    Quantidade: Yup.string()
      .required('Campo Obrigatório!')
      .matches(/^[1-9]\d*$/, 'Deve ser um número inteiro maior que zero'),
    // Obrigatório porque é o que define o vencimento das parcelas. Aceita um valor
    // (intervalo fixo) ou vários separados por vírgula (dias exatos de cada parcela).
    // Os separadores aceitos são os mesmos que FN_CONDICAOPAGAMENTO_PARCELAS
    // normaliza — se divergirem, a tela recusa algo que o banco entenderia (ou pior,
    // aceita algo que o banco lê errado).
    DiasParcelas: Yup.string()
      .required('Campo Obrigatório!')
      .matches(
        /^\s*\d+([\s,;/xX-]+\d+)*\s*$/,
        'Informe os dias em números, separados por vírgula (ex.: 30 ou 15,21,28)'
      )
      .test(
        'qtd-casa-com-dias',
        'A quantidade de parcelas deve ser igual à quantidade de dias informados',
        function (val) {
          const dias = String(val ?? '').split(/[\s,;/xX-]+/).filter((d) => d.trim() !== '');
          // Só cobra o casamento quando há mais de um dia: um valor é intervalo fixo.
          if (dias.length < 2) return true;
          return Number(this.parent?.Quantidade) === dias.length;
        }
      ),
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO DE CONDIÇÕES DE PAGAMENTO'} className={'mb-5'} />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form>
            <BoxButtons>
              <Button
                variant='contained'
                onClick={() => history.back()}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>
            <fieldset disabled={duploClick}>
            <Field
              name='Descricao'
              as={TextField}
              label='Descrição'
              type='text'
              error={Boolean(errors?.Descricao)}
              helperText={errors?.Descricao}
            />
            <Field
              name='TipoUtilizacao'
              as={TextField}
              //id="outlined-password-input"
              label='Tipo Utilização'
              type='text'
              error={Boolean(errors?.TipoUtilizacao)}
              helperText={errors?.TipoUtilizacao}
            />
            <Field
              name='TipoParcelamento'
              as={TextField}
              id='outlined-password-input'
              label='Tipo Parcelamento'
              type='text'
              error={Boolean(errors?.TipoParcelamento)}
              helperText={errors?.TipoParcelamento}
            />
            <Field
              name='Quantidade'
              as={TextField}
              id='outlined-password-input'
              label='Quantidade'
              type='text'
              error={Boolean(errors?.Quantidade)}
              helperText={errors?.Quantidade}
            />
            {/* Define de fato o vencimento das parcelas (a Descrição é só rótulo).
                Um valor = intervalo fixo; vários = dias exatos de cada parcela. */}
            <Field
              name='DiasParcelas'
              as={TextField}
              label='Dias das parcelas *'
              type='text'
              placeholder='30  ou  15,21,28  ou  15/20/30'
              error={Boolean(errors?.DiasParcelas)}
              helperText={
                errors?.DiasParcelas ||
                'Dias corridos após a data de referência. Um valor repete o intervalo (30 = 30/60/90...); vários definem cada parcela (15,21,28).'
              }
            />
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
